// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__FdAwy","title":"BackImages_title__1-kgm","images":"BackImages_images__2Lmar"};